import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { PlaidLink } from '../PlaidLink'
import { usePlaid } from './PlaidContext'
import { cn } from '@mortgage-pos/ui/utils/cn'
import Error from '@mortgage-pos/ui/assets/plaid-error.svg'
import { useStoreActions, useStoreState } from '@mortgage-pos/ui/store'
import Button, { ButtonVariants } from '@mortgage-pos/ui/components/Button'
import { MessageTypes, QuestionSetSlug, Routes } from '@mortgage-pos/types'

const Failure: FC = () => {
  const navigate = useNavigate()
  const { setUsePlaidUpload, plaidModalOpen } = usePlaid()
  const { isMiniFlow } = useStoreState((state) => state.questionnaire)
  const { closeMiniFlow } = useStoreActions((state) => state.questionnaire)

  const uploadManuallyHandler = () => {
    setUsePlaidUpload(false)

    if (isMiniFlow) {
      closeMiniFlow({
        parentMessage: {
          name: MessageTypes.MiniFlowConditionRequest,
          payload: {
            condition: 'Upload 2 months of asset statements',
          },
        },
      })
    } else {
      navigate(
        `/${Routes.APP_1003}?question-set=${QuestionSetSlug.ApplyPurchase}`
      )
      window.location.reload()
    }
  }

  return (
    <div className="plaid-assets">
      <div
        className={cn('plaid-assets__content', {
          'plaid-assets__hidden': plaidModalOpen,
        })}
      >
        <div className="plaid-assets__logo">
          <img src={Error} alt="Error" height={50} />
        </div>
        <div className="plaid-assets__header">
          <p className="plaid-assets__title">Oopsie</p>
          <p className="plaid-assets__heading">Somthing went wrong...</p>
          <p className="plaid-assets__description">
            Although we were unable to link your information through Plaid, your
            data is essential for us to proceed. Please feel free to retry using
            Plaid or input your details manually to continue.
          </p>
        </div>

        <div className="plaid-assets__failure-cta-container">
          <Button
            className="plaid-assets__cta-button"
            onClick={uploadManuallyHandler}
            variant={ButtonVariants.next}
            content="Manually enter"
          />
          <PlaidLink
            modifierClass="plaid-assets__retry-btn"
            variant={ButtonVariants.default}
            content="Retry Plaid"
            btnClassName="plaid-assets__cta-link"
          />
        </div>
      </div>
    </div>
  )
}

export default Failure
